import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ApplicationDashboardComponent } from './components/application-dashboard/application-dashboard.component';
import { HostInstitutionComponent } from './components/host-institution/host-institution.component';
import { PointOfContactComponent } from './components/point-of-contact/point-of-contact.component';
import { TrackRecordComponent } from './components/track-record/track-record.component';
import { InfrastructureComponent } from './components/infrastructure/infrastructure.component';
import { IntentForEoiComponent } from './components/intent-for-eoi/intent-for-eoi.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard', component: ApplicationDashboardComponent, data: { title: 'Dashboard', animation: 's1' }
  },
  {
    path: 'host-institution', component: HostInstitutionComponent, data: { title: 'Host Institution', animation: 's1' }
  },
  {
    path: 'point-of-contact', component: PointOfContactComponent, data: { title: 'Point Of Contact', animation: 's1' }
  },
  {
    path: 'track-record', component: TrackRecordComponent, data: { title: 'Track Record', animation: 's1' }
  },
  {
    path: 'infrastructure', component: InfrastructureComponent, data: { title: 'Infrastructure', animation: 's1' }
  },
  {
    path: 'intent-for-eoi', component: IntentForEoiComponent, data: { title: 'Intent For Eoi', animation: 's1' }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PreIncubationRoutingModule { }
